import React, { createContext, useState } from 'react';
import ROUTES from '../routes';

type StormModelDataSchema = {
  open: boolean;
  defaultRedirectUrl: string;
  locationState: any;
};

export const StormModeInterceptContext = createContext<{
  stormModeInterceptModal: StormModelDataSchema;
  setStormModeInterceptModal: React.Dispatch<
    React.SetStateAction<StormModelDataSchema>
  >;
}>({
  stormModeInterceptModal: {
    open: false,
    defaultRedirectUrl: ROUTES.ACCOUNT,
    locationState: undefined,
  },
  setStormModeInterceptModal: () => null,
});

export const StormModeInterceptProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [stormModeInterceptModal, setStormModeInterceptModal] = useState<
    StormModelDataSchema
  >({
    open: false,
    defaultRedirectUrl: ROUTES.ACCOUNT,
    locationState: undefined,
  });

  return (
    <StormModeInterceptContext.Provider
      value={{
        stormModeInterceptModal,
        setStormModeInterceptModal,
      }}
    >
      {children}
    </StormModeInterceptContext.Provider>
  );
};
